import { Component, Input } from '@angular/core';
import { ElementComponent } from '../element-wyswyg/element-wyswyg.component';

@Component({
  selector: 'app-file-rendered',
  templateUrl: './file-rendered.component.html',
  styleUrls: ['./file-rendered.component.css']
})
export class FileRenderedComponent  extends ElementComponent {
  @Input()
  public override data: any = {}

}
